import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import SplitElementIcon from '@mui/icons-material/Carpenter'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined'
import MapOutlinedIcon from '@mui/icons-material/MapOutlined'
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined'
import PolylineOutlinedIcon from '@mui/icons-material/PolylineOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined'
import ViewColumnOutlinedIcon from '@mui/icons-material/ViewColumnOutlined'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import { SxProps, Theme } from '@mui/material'

export { SplitElementIcon }

export const formSectionIconSx: SxProps<Theme> = { color: 'grey.600', padding: '2px' }

export const FormSectionIcons = {
  geometry: <PolylineOutlinedIcon sx={formSectionIconSx} />,
  assembly: <LayersOutlinedIcon sx={formSectionIconSx} />,
  problems: <WarningAmberOutlinedIcon sx={formSectionIconSx} />,
  actions: <AutoFixHighIcon sx={formSectionIconSx} />,
  copy: <ContentCopyIcon sx={formSectionIconSx} />,
  documentation: <DescriptionOutlinedIcon sx={formSectionIconSx} />,
  stiffening: <ShieldOutlinedIcon sx={formSectionIconSx} />,
  settings: <SettingsOutlinedIcon sx={formSectionIconSx} />,
  plans: <MapOutlinedIcon sx={formSectionIconSx} />,
  wallRips: <ViewColumnOutlinedIcon sx={formSectionIconSx} />,
  openings: <MeetingRoomOutlinedIcon sx={formSectionIconSx} />,
  split: <SplitElementIcon sx={formSectionIconSx} />,
}
